/* tslint:disabled */
/* eslint-disable */
/**
 * Report Manager
 * The service allows to request reports, download, update and delete them.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * ReportStatusEnum should be synced with Status table in DB this will give us ability to implement server filtering in SQL queries NOTE: when making changes in this enum you need add update statements to cmd/reportmanager/migrations
 * @export
 * @enum {string}
 */
export enum ReportStatusEnum {
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Expiring = 'EXPIRING'
}

export function ReportStatusEnumFromJSON(json: any): ReportStatusEnum {
  return json as ReportStatusEnum
}

export function ReportStatusEnumToJSON(value?: ReportStatusEnum): any {
  return value as any
}
